import store from "../store";

export default (to, from, next) => {
  if (store.getters.user && store.getters.user.academic) {
    next();
  } else {
    next({
      name: "Login",
      query: {
        redirect: to.fullPath
      }
    });
  }
};
